import { useDispatch } from "react-redux";
import { Button } from "./../../shared/button/button";
import { TitleStyled } from "./../../shared/styles";
import { ContainerSyled } from "./styles";
import { useLocation } from "react-router-dom";
import { Avatar, Box, useMediaQuery } from "@mui/material";
import { toggleMenu } from "../../redux/reducers/settings";
import { useGetUser } from "../../hooks/useGetUser";
import { useState } from "react";
import { DropdownProfile } from "./dropdown-profile";

export const TopMenu = () => {
  const [showMenu, setShowMenu] = useState(false);

  const { user, isLoadingUser } = useGetUser();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");

  function formatPathname(route) {
    const segment = route.split("/")[1];
    return segment ? segment.charAt(0).toUpperCase() + segment.slice(1) : "";
  }

  function handleOpenMenu() {
    setShowMenu((prev) => !prev);
  }

  return (
    <ContainerSyled>
      {isMobile && (
        <Button
          startIcon={"DotsThree"}
          iconSize={24}
          iconColor={"#0F110C"}
          onClick={() => dispatch(toggleMenu())}
          type={"regular"}
          buttonStyles={{
            width: "fit-content",
            backgroundColor: "#EDEDED",
            borderRadius: "8px",
          }}
        />
      )}
      <TitleStyled>{formatPathname(pathname)}</TitleStyled>
      <Box position={"relative"}>
        <Avatar
          sx={{
            bgcolor: "#1976d2",
            border: "2px solid #EDEDED",
            transition: ".2s",
            "&:hover": {
              cursor: "pointer",
              backgroundColor: "#0F110C",
              borderColor: "#1976d2",
            },
          }}
          onClick={handleOpenMenu}
          src={user?.imagen}
        >
          {user?.email?.charAt(0)?.toUpperCase()}
        </Avatar>
        {showMenu && (
          <DropdownProfile
            user={user}
            isLoadingUser={isLoadingUser}
            handleClose={handleOpenMenu}
          />
        )}
      </Box>
    </ContainerSyled>
  );
};
